import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-quibbler-hp7-undesirable-no1",
  name: `The Quibbler\n'Undesirable No.1'`,
  nameFormatted: {
    primary: "The Quibbler",
    secondary: "'Undesirable No.1'",
  },
  origin: `Harry Potter and the Deathly Hallows`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
